module.exports = __webpack_public_path__ + "static/media/Robotobold.15a913e1.woff2";